import React from "react"
import { useFieldArray, Controller, useFormContext } from "react-hook-form"
import Flatpickr from "react-flatpickr"
import Moment from "moment"

//controls
import { Col, Row, Button, FormFeedback } from "reactstrap"

export default ({ nestIndex }) => {
  const methods = useFormContext()
  const { control, formState, setValue, getValues } = methods
  const { errors } = formState

  const { fields, remove, append } = useFieldArray({
    control,
    name: `availability[${nestIndex}].CenterOpeningDetail`,
  })

  return fields.map((item, k) => {
    return (
      <Row key={`times${k}`} style={{ marginBottom: 10 }}>
        <Col sm={5}>
          <Controller
            name={`availability[${nestIndex}].CenterOpeningDetail[${k}].StartTime`}
            control={control}
            render={({ field }) => (
              <>
                <Flatpickr
                  {...field}
                  className="form-control d-block"
                  id={`availability[${nestIndex}].CenterOpeningDetail[${k}].StartTime`}
                  options={{
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: "h:i K",
                  }}
                  value={
                    Moment(field.value).isValid()
                      ? Moment(field.value).format("h:mm a")
                      : field.value
                  }
                  onChange={(selectedDates, dateStr, instance) => {
                    setValue(
                      `availability[${nestIndex}].CenterOpeningDetail[${k}].StartTime`,
                      dateStr
                    )
                  }}
                  required
                />
              </>
            )}
          />
        </Col>
        <Col sm={5}>
          <Controller
            control={control}
            name={`availability[${nestIndex}].CenterOpeningDetail[${k}].EndTime`}
            render={({ field }) => (
              <>
                <Flatpickr
                  {...field}
                  className="form-control d-block"
                  id={`availability[${nestIndex}].CenterOpeningDetail[${k}].EndTime`}
                  options={{
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: "h:i K",
                  }}
                  value={
                    Moment(field.value).isValid()
                      ? Moment(field.value).format("h:mm a")
                      : field.value
                  }
                  onChange={(selectedDates, dateStr, instance) => {
                    setValue(
                      `availability[${nestIndex}].CenterOpeningDetail[${k}].EndTime`,
                      dateStr
                    )
                  }}
                />
              </>
            )}
          />
        </Col>
        <Col sm={2}>
          <>
            {" "}
            <Button
              hidden={k == 0}
              onClick={() => remove(k)}
              style={{ height: "40px", marginTop: 0 }}
            >
              Delete
            </Button>
            <Button
              hidden={k > 0}
              onClick={() =>
                append({
                  CenterOpeningDetailID: 0,
                  StartTime: "",
                  EndTime: "",
                })
              }
              style={{ marginLeft: "10px" }}
            >
              Add
            </Button>
          </>
        </Col>
      </Row>
    )
  })
}
